import React from 'react'
import PropTypes from 'prop-types'
import { Copy, Button, Flex, themeFontWeight, HorizontalRule } from '@elparking/components'
import { FormattedMessage } from 'react-intl'

import styled from 'styled-components'

import PriceContainer from '../PriceContainer'

export const ButtonSplit = styled(Button)`
    font-size: 14px;
    font-weight: ${themeFontWeight('book')};
    letter-spacing: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;
`

function ButtonWithPrice ({originalPrice, totalPrice, onClick}) {
    return (
        <ButtonSplit
          onClick={() => onClick()}
          width='100%'
          height='36px'
          fontSize='small'
          marginTop='12px'
        >
            <Flex width='45%'>
                <PriceContainer originalPrice={originalPrice} totalPrice={totalPrice} color='white'/>
            </Flex>
            <Flex width='10%' justifyContent='center'>
                <HorizontalRule.vertical background='gray'/>
            </Flex>
            <Copy padding='0' align='center' color='white' size='medium' fontWeight='book' width='45%'>
                <FormattedMessage defaultMessage='Pedir cita' />
            </Copy>
        </ButtonSplit>
    )
}

ButtonWithPrice.propTypes = {
    onClick: PropTypes.func,
    originalPrice: PropTypes.shape({
        amount: PropTypes.number,
        currency: PropTypes.string,
    }),
    totalPrice: PropTypes.shape({
        amount: PropTypes.number,
        currency: PropTypes.string,
    }).isRequired,
}

export default ButtonWithPrice
